import { useState } from "react";
import apiMaestras from "../api/Maestras/api-maestras";
import { DocumentoAdministrativo } from "../models/Maestras/maestras.model";

export const useGestionDocumentosAdministrativos = () => {
    const [cantidadPaginas, setCantidadPaginas] = useState(10);
    const cambiarCantidadPaginas = (e: any, value: any) => {
        setCantidadPaginas(value);
    };


    const [documentosAdministrativos, setDocumentosAdministrativos] = useState<DocumentoAdministrativo[]>([]);
    const obtenerDocAdministrativos = async() => {
        try {
            const documentosAdministrativos = await apiMaestras.obtenerDocumentosAdminsitrativos();
            setDocumentosAdministrativos(documentosAdministrativos);
        } catch (error) {
            console.log(error);
        }
    }

    return {
        cantidadpaginas: cantidadPaginas,
        cambiarCantidadPaginas,
        documentosAdministrativos,
        obtenerDocAdministrativos
    } 
}
